import React, { useState, useEffect } from 'react';
import '../../scss/roles.scss';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../layout/Footer';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import SearchSection from '../Reusables/SearchSection';
import getProfile from '../actions/Profile.js';
import Spinner from '../Reusables/Spinner';
import { useNavigate,useLocation } from "react-router-dom";
import edit from '../../images/common/edit.png';
import trash from '../../images/common/trash.png';
import editDark from '../../images/common/edit-dark.png';
import trashDark from '../../images/common/trash-dark.png';
import placeholder from '../../images/common/logo-placeholder.png';
import upsort from '../../images/common/upsort.png';
import downsort from '../../images/common/downsort.png';
import ProfileHeader from '../layout/ProfileHeader';
import { useDispatch } from 'react-redux';
import { parseBreadcrumbsList } from '../../store/Actions';
import DeleteItem from '../popups/DeleteItem';
import RolepopUp from '../popups/Rolepopup';
import Cookies from 'js-cookie';
import RefreshToken from '../actions/RefreshToken';
import Snackbars from '../Reusables/Snackbar';

function Roles(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    // const accessToken =  Cookies.get('access_token');
    const [enable, setEnable] = useState(true);
    const [isLoading, setLoading] = useState(true);
    const [isNewClicked, setNewClick] = useState(false);
    const [ListValues, setListValues] = useState(null);
    const [show, setShow] = useState(false);
    const [deleteProjectId, setDeleteProjectId] = useState(null);
    const [deleteproject, setDeleteproject] = useState('');
    const [roleId, setRoleId] = useState(null);
    const [editstatus, setEdit] = useState(false);
    const [downloadtype, setDownloadtype] = useState('');
    const [editDetails, setRoleType] = useState([]);
    const [downloadarray, setDownloadarray] = useState([]);
    const [errormsg, setErrorMessage] = useState('');
    const [create, setCreate] = useState(false);
    const [editPopup, setEditstatus] = useState(false);
    const [open, setOpen] = useState(null)

    const searchValues = {
        isFilter: false,
        isCreate: false,
        placeholder: "Search Roles"
    }
    const breadcrumbsList = [
        { "name": "Home", "url": "" },
        { "name": "Roles", "url": "roles" }
    ];
    const tableHeaders = [
        { "name": "Name", "sort": false, "width": "233px" },
        { "name": "Default", "sort": false, "width": "224px" },
        { "name": "Actions", "sort": false, "width": "32px" }
    ];
    const headers = [
        { label: "Role Name", key: "roleName" },
        { label: "Default", key: "default" },

    ];  
    const filename = 'Roles';

    const addDarkImage = (e, index) => {
        const editElement = document.getElementById('edit'+index)
        const trashElement = document.getElementById('trash'+index)
        editElement.src = editDark;
        trashElement.src = trashDark;
    }

    const removeDarkImage = (e, index) => {
        const editElement = document.getElementById('edit'+index)
        const trashElement = document.getElementById('trash'+index)
        editElement.src = edit;
        trashElement.src = trash;
    }

    const handleClose = () => {
        setShow(false);
    }

    const handleShow = () => {
        setShow(true);
    }

    const  deleteContact = () =>  {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getProfile.DeleteRole(`/api/roles/delete?roleId=${deleteProjectId}`, accesstoken, (data) => {
                    if (data.status == 200) {
                        console.log("Delete Brand", data.data.data);
                        handleClose();
                        setDeleteproject(deleteProjectId);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }
    const  deleteRole = (event, id) => {
        event.stopPropagation();
        setDeleteProjectId(id);
        handleShow();
    }
    const EditRole = (event, item) => {
        setErrorMessage('');
        event.stopPropagation();
        setNewClick(true);
        setRoleId(item.idRoles);
        setOpen(false);
        setRoleType(item)
        setEditstatus(!editPopup)
    }
    const RolesApi = (url) => {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getProfile.GetRole(url, accesstoken, (data) => {
                    if (data.status == 200) {
                        setListValues(data.data.data);
                        setLoading(false);
                        setDownloadarray(data.data.data);
                        setOpen(false);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    const GetContacts = (details) => {
        console.log(details);
        const errorDetails = details
        details.RoleId = roleId;
        if(details.Default == "True") {
            details.Default = true
        } else if(details.Default == "False") {
            details.Default = false
        }
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getProfile.EditAddContact('/api/roles/save', details, accesstoken, (data) => {
                    setEnable(true);
                    if (data.status == 200) {
                        console.log(data);
                        setEdit(!editstatus)
                        setNewClick(false);

                    }
                    else if(data.status == 400 || data.status == 404) {
                        setErrorMessage(data.data.message);
                        window.scroll(0,0);
                        console.log(editDetails)
                        setRoleType(errorDetails)
                        console.log(details)
                        setOpen(true)
                    } else if(data.status == 401) {
                        navigate("/login")
                    }

                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }
    useEffect(() => {
        setErrorMessage('')
        window.scroll(0, 0);
        dispatch(parseBreadcrumbsList(breadcrumbsList));
        const params = new URLSearchParams(location.search);
        const search = params.has('search') ? params.get('search') : '';
        search ? RolesApi(`/api/roles?search=${search}`): RolesApi(`/api/roles`);
    }, [deleteproject,editstatus, downloadtype])

    // useEffect(() => {
    //     const params = new URLSearchParams(location.search);
    //     const search = params.has('search') ? params.get('search') : '';
    //     var url = null
    //     search ? url = `/api/roles?search=${search}`: url = `/api/roles`;
    //     getProfile.GetRole(url, accessToken, (data) => {
    //         if (data.status == 200) {
    //             setLoading(false);
    //             setDownloadarray(data.data.data)
    //         }
    //     });
    // }, [downloadtype])
    
    const createNewUser = () => {
        setNewClick(true);
        setRoleId(0);
        setErrorMessage('')
        setCreate(!create);
        setOpen(false); 
    }
    
    const callSearchApi = (query) => {
        navigate(`/roles/?search=${query}`);
        RolesApi(`/api/roles?search=${query}`);
    }

    const handleCloseEntities = () => {
        window.scroll(0, 0);
        setNewClick(false);
    }

    return(
        <>
        <div className="roles-profile-container">
            <Header />
            <div className="row users-sub-container">
                <Sidebar />
                <div className='col-10 users-body-container'>
                    <div className='sub-header'>
                        <Breadcrumbs/>
                    </div>

                <ProfileHeader/>

                <div className='user-list-container'>
                    <SearchSection values={searchValues} handleFilter="" setDownloadtype="" downloadtype=""
                    downloadarray={downloadarray} headers={headers} filename={filename}
                        callSearchApi={(query) => callSearchApi(query)}  navigateTo={createNewUser} pageType="Roles"/> 
                    {isLoading ? 
                        (<Spinner/>) : 
                        (<div  className='table-view-container'>
                            <div id="print" className='list-items'>
                                <table>
                                    <thead>
                                        <tr className='heading-row'>
                                            {tableHeaders.map((item, index) => {
                                                return (
                                                    <>
                                                        <th className={`heading-data${index}, index == 0 ? "heading": "", index == 2 ? "action-heading": ""`} style={{ minWidth: `${item.width}`,textAlign: "left" }}>
                                                            <div className='flex-display'>
                                                                <div className='label'>{item.name}</div>
                                                            </div>                                  
                                                        </th>
                                                    </>
                                                )
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(ListValues != null && ListValues.length > 0) && ListValues.map((item, index) => {
                                            return (
                                                <tr id={index} onMouseOver={(e) => addDarkImage(e, index)} onMouseLeave={(e) => removeDarkImage(e, index)}>
                                                    <td className='data0'>{item.roleName != null && item.roleName}</td>
                                                    <td className='data1'>{item.default === false ? "False" : "True"}</td>   
                                                    <td className='data7 action'>
                                                        <img id={`${'edit'+index}`} className='edit' src={edit} alt="edit" onClick={(event)=>EditRole(event,item)}></img>
                                                        <img id={`${'trash'+index}`} className='trash' src={trash} alt="delete" onClick={(event)=>deleteRole(event,item.idRoles)}></img>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>)
                    }
                </div>
            </div>
                </div>
                <Footer />
                <RolepopUp enable={enable} setEnable={setEnable} errormsg={null} show={isNewClicked} roleId={roleId} editDetails={editDetails} handleClose={handleCloseEntities} create={create} editPopup={editPopup} getContactDetails={GetContacts}
                />
                <Snackbars error={errormsg} open={open} setOpen={setOpen}/>
                <DeleteItem show={show} handleClose={handleClose} deleteApiCall={deleteContact} enable={true}/>
            </div>
        </>
    )
}

export default Roles;